import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { selectConfigration } from "redux/slices/configrationSlice";
import LookupTable from "redux/models/lookupTable";
import Job from "redux/models/job";
import Client from "redux/models/client";

import { lookupTablesForCandidates } from "config/lookupTables";
import { getColumns } from "../columns";

export const useUploadPageData = () => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [classList, setClassList] = useState([]);
  const [recruiters, setRecruiters] = useState([]);

  const lookupData = useSelector(selectConfigration).lookup;

  const fetchPageData = useCallback(async () => {
    setLoading(true);
    try {
      const [, jobsRes, classRes, recruitersRes] = await Promise.all([
        Promise.all(
          lookupTablesForCandidates.map((item) =>
            dispatch(
              LookupTable.getData(
                item.reduxKey,
                item.apiEndPoint,
                [],
                false,
                true,
                {
                  is_visible: 1,
                },
              ),
            ),
          ),
        ),
        Job.getAllJobsForExcelUpload(),
        Client.getAllClassForExcelUpload(),
        Client.getAllRecruiterForExcelUpload(),
      ]);
      setJobs(jobsRes);
      setClassList(classRes);
      setRecruiters(recruitersRes);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchPageData();
  }, [fetchPageData]);

  const columns = getColumns({ jobs, classList, recruiters, lookupData });

  return { loading, columns, lookupData };
};
